// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a8105714","43":"9357ef3b","244":"34750e89","351":"aeae4761","736":"905236ef"}[chunkId] + ".chunk.js";
};